import { Modal } from '@querodelivery/uni-react';
import JsonView from '@/Shared/JsonView';
import { MODAL_WIDTH } from '@/_constants/styles';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { closeEventModal as dispatchCloseEventModal } from '@/_store/modules/layout';
import { selectEventModalData } from '@/_store/modules/layout/selectors';

function EventModal() {
  const dispatch = useAppDispatch();

  const eventModalData = useAppSelector(selectEventModalData);

  function closeEventModal() {
    dispatch(dispatchCloseEventModal());
  }

  return (
    <Modal
      isOpen={!!eventModalData}
      onClose={closeEventModal}
      header="Evento"
      width={MODAL_WIDTH.lg}
    >
      <JsonView name="Evento" source={eventModalData} collapsed={false} show />
    </Modal>
  );
}

export default EventModal;
